export function ensureArray(input) {
    return Array.isArray(input) ? input : [input];
}
export function uniq(input) {
    return input.filter((item, index) => input.indexOf(item) === index);
}
//# sourceMappingURL=array.js.map